export default {
  methods: {
    openUpgradeModal() {
      this.$store.commit('userSubscriptions/setOpenUpgradeModal', true)
    }
  }
}
